import { render } from "./SourceCatalog.vue?vue&type=template&id=b9a94514&scoped=true"
import script from "./SourceCatalog.vue?vue&type=script&lang=js"
export * from "./SourceCatalog.vue?vue&type=script&lang=js"

import "./SourceCatalog.vue?vue&type=style&index=0&id=b9a94514&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9a94514"]])

export default __exports__